<template>
  <div id="app">
    <cookie-law>
      <div slot-scope="props">
        <p>
          This site uses cookies. By continuing to use this site you agree to our use of cookies.
        </p>
        <button class="cookie-btn" @click="props.accept"><span>I accept</span></button>
      </div>
    </cookie-law>
    <div class="page-changer" id="page-changer">
      <div>
        <preloader />
      </div>
    </div>
    <div
      :class="`_${ navigationColor } _background-${ backgroundColor }`"
    >
      <router-link
        :class="`menu-logo ${hideNavigationByScroll ? 'isHiddenByScroll' : ''} _${ navigationColor } a-link`"
        :event="''"
        :to="{ name: 'home' }"
        @click.native.prevent="onFollowLink({ name: 'home' })"
        @mouseenter="onLogoHover( $event )"
        @mouseleave="onLogoHoverOut( $event )"
        id="logo"
      >
        <svg width="158" height="42" viewBox="0 0 158 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.9 15.4V15.7H9V15.4H10.7L8.9 10.4H3.6L1.7 15.4H3.5V15.7H0V15.4H1.2L7.2 0L12.8 15.4H13.9ZM8.8 10.1L6.4 3.4L3.8 10.1H8.8Z" fill="black"/>
          <path d="M28.1969 15.4V15.7H23.2969V15.4H24.9969L23.1969 10.4H17.8969L15.9969 15.4H17.7969V15.7H14.2969V15.4H15.4969L21.4969 0L27.0969 15.4H28.1969ZM23.0969 10.1L20.5969 3.4L17.9969 10.1H23.0969Z" fill="black"/>
          <path d="M38.3031 10.1008H34.7031V13.7008H33.8031V10.1008H30.2031V9.40078H33.8031V5.80078H34.7031V9.40078H38.3031V10.1008Z" fill="black"/>
          <path d="M0.601562 40.6016H2.10156V25.9016H0.601562V25.6016H7.40156C9.10156 25.6016 10.5016 25.9016 11.7016 26.6016C12.9016 27.3016 13.8016 28.2016 14.5016 29.3016C15.1016 30.5016 15.5016 31.8016 15.5016 33.2016C15.5016 34.6016 15.2016 35.9016 14.5016 37.1016C13.9016 38.3016 13.0016 39.2016 11.8016 39.9016C10.6016 40.6016 9.40156 40.9016 7.90156 40.9016H0.601562V40.6016ZM7.60156 40.6016C8.80156 40.6016 9.90156 40.2016 10.7016 39.5016C11.5016 38.8016 12.1016 37.9016 12.5016 36.8016C12.9016 35.7016 13.1016 34.5016 13.1016 33.2016C13.1016 32.1016 12.8016 30.9016 12.2016 29.8016C11.6016 28.7016 10.8016 27.7016 9.80156 27.0016C8.80156 26.3016 7.60156 25.9016 6.40156 25.9016H4.00156V40.6016H7.60156Z" fill="black"/>
          <path d="M17.1016 40.6016H18.6016V25.9016H17.1016V25.6016H27.6016V27.3016H26.9016V25.9016H20.5016V32.9016H25.6016V31.3016H26.0016V34.8016H25.7016V33.2016H20.6016V40.6016H27.5016V39.1016H28.2016V40.9016H17.2016V40.6016H17.1016Z" fill="black"/>
          <path d="M30.2031 25.9016H29.2031V25.6016H34.0031V25.9016H32.3031L36.9031 38.2016L41.3031 25.9016H39.7031V25.6016H43.2031V25.9016H41.8031L36.1031 41.3016L30.2031 25.9016Z" fill="black"/>
          <path d="M44.2031 40.6016H45.7031V25.9016H44.2031V25.6016H54.7031V27.3016H54.0031V25.9016H47.6031V32.9016H52.7031V31.3016H53.0031V34.8016H52.7031V33.2016H47.6031V40.6016H54.5031V39.1016H55.2031V40.9016H44.2031V40.6016Z" fill="black"/>
          <path d="M56.7969 40.6016H58.2969V25.9016H56.7969V25.6016H60.1969V40.6016H66.5969V39.1016H67.2969V40.9016H56.7969V40.6016Z" fill="black"/>
          <path d="M71.9016 40.0984C70.7016 39.3984 69.8016 38.3984 69.1016 37.1984C68.4016 35.9984 68.1016 34.6984 68.1016 33.2984C68.1016 31.8984 68.4016 30.5984 69.1016 29.3984C69.8016 28.1984 70.7016 27.1984 71.9016 26.4984C73.1016 25.7984 74.4016 25.3984 75.8016 25.3984C77.2016 25.3984 78.4016 25.7984 79.6016 26.4984C80.8016 27.1984 81.7016 28.1984 82.4016 29.3984C83.1016 30.5984 83.4016 31.8984 83.4016 33.2984C83.4016 34.6984 83.1016 35.9984 82.4016 37.1984C81.7016 38.3984 80.8016 39.3984 79.6016 40.0984C78.4016 40.7984 77.2016 41.1984 75.8016 41.1984C74.4016 41.1984 73.1016 40.7984 71.9016 40.0984ZM79.1016 39.8984C79.7016 39.2984 80.2016 38.5984 80.5016 37.6984C80.8016 36.7984 81.0016 35.7984 81.0016 34.6984C81.0016 33.2984 80.7016 31.8984 80.1016 30.5984C79.5016 29.1984 78.7016 28.0984 77.8016 27.1984C76.9016 26.2984 75.8016 25.8984 74.7016 25.8984C73.7016 25.8984 72.9016 26.1984 72.3016 26.7984C71.7016 27.3984 71.2016 28.1984 70.9016 29.1984C70.6016 30.1984 70.5016 31.2984 70.5016 32.3984C70.5016 33.6984 70.8016 34.9984 71.4016 36.2984C72.0016 37.5984 72.8016 38.6984 73.8016 39.4984C74.8016 40.2984 75.8016 40.6984 76.9016 40.6984C77.7016 40.6984 78.5016 40.3984 79.1016 39.8984Z" fill="black"/>
          <path d="M85.1016 40.6016H86.6016V25.9016H85.1016V25.6016H90.9016C92.7016 25.6016 94.0016 26.0016 94.9016 26.8016C95.8016 27.6016 96.2016 28.7016 96.2016 30.0016C96.2016 30.9016 96.0016 31.7016 95.5016 32.4016C95.1016 33.1016 94.4016 33.6016 93.6016 34.0016C92.8016 34.4016 91.9016 34.5016 90.8016 34.5016H89.3016V34.2016H90.8016C92.9016 34.2016 94.0016 32.8016 94.0016 30.1016C94.0016 28.7016 93.7016 27.7016 93.1016 27.0016C92.5016 26.3016 91.6016 25.9016 90.5016 25.9016H88.4016V40.6016H90.0016V40.9016H85.1016V40.6016Z" fill="black"/>
          <path d="M99.6031 28.1016V40.6016H101.103V40.9016H97.7031V40.6016H99.2031V25.9016H97.7031V25.6016H100.703L106.903 38.5016L113.803 25.6016H115.803V25.9016H114.303V40.6016H115.803V40.9016H110.903V40.6016H112.403V29.3016L106.003 41.2016L99.6031 28.1016Z" fill="black"/>
          <path d="M117.297 40.6016H118.797V25.9016H117.297V25.6016H127.797V27.3016H127.097V25.9016H120.697V32.9016H125.797V31.3016H126.097V34.8016H125.797V33.2016H120.697V40.6016H127.597V39.1016H128.297V40.9016H117.297V40.6016Z" fill="black"/>
          <path d="M131.9 27.6016V40.6016H133.4V40.9016H130V40.6016H131.5V25.9016H130V25.6016H133L141.7 37.7016V25.9016H140.2V25.6016H143.6V25.9016H142.1V41.5016L131.9 27.6016Z" fill="black"/>
          <path d="M148.502 40.6016H150.002V25.9016H145.502V27.9016H144.602V25.6016H157.202V27.9016H156.302V25.9016H152.002V40.6016H153.502V40.9016H148.602V40.6016H148.502Z" fill="black"/>
        </svg>
      </router-link>
      <a
        :class="`menu-burger ${hideNavigationByScroll ? 'isHiddenByScroll' : ''} ${ isMenuBurgerVisible ? '' : 'isHidden' }`"
        href="#"
        id="burger"
        @click.prevent="onMenuTooggle"
      >
        <span :class="`${showMenu ? 'active' : ''}`"></span>
      </a>
      <div class="menu" ref="menu">
        <div
          class="menu__background"
          ref="menuBackground"
          @click="onMenuHide"
        >
          
        </div>
        <div class="menu__container" ref="menuContainer">
          <!-- <div
            class="menu__close"
            @click="onMenuHide">
            <span></span>
          </div> -->
          <!-- <div class="menu__footer">
            {{ new Date().getFullYear() }}. AD CASA.
          </div> -->
          <div class="menu__inner">
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'projects', params: { activeSection: 'all' } }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'all' } } )"
                class="a-link menu__title"
              >{{ $t('menu_projects') }}</router-link>
              <div class="menu__nav">
                <div class="">
                  <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'architecture' } }"
                    @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'architecture' } } )"
                    class="a-link"
                  >{{ $t('section_architecture') }}</router-link>
                </div>
                <div class="">
                  <router-link
                    :event="''"
                    :to="{ name: 'projects', params: { activeSection: 'design' } }"
                    @click.native.prevent="onMenuHide(); onFollowLink( { name: 'projects', params: { activeSection: 'design' } } )"
                    class="a-link"
                  >{{ $t('section_design') }}</router-link>
                </div>
              </div>
            </div>
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'company' }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'company' } )"
                class="menu__title a-link"
              >{{ $t('menu_company') }}</router-link>
            </div>
            <div class="menu__block">
              <router-link
                :event="''"
                :to="{ name: 'contacts' }"
                @click.native.prevent="onMenuHide(); onFollowLink( { name: 'contacts' } )"
                class="menu__title a-link"
              >{{ $t('menu_contacts') }}</router-link>
              <!-- <div class="menu-nav">
                <div class="menu__link">
                  <a @click="onMenuHide" href="https://www.facebook.com/adorohovproject/" target="_blank">Facebook</a>
                </div>
                <div class="menu__link">
                  <a @click="onMenuHide" href="http://instagram.com/ad_project_" target="_blank">Instagram</a>
                </div>
              </div> -->
            </div>
            <!-- <div class="menu__social">
              <a href="https://www.instagram.com/ad_casa_/" target="_blank">
                <img src="/images/contact/Instagram.svg" alt="instagram" />
              </a>
              <a href="http://" target="_blank" class="social_disabled">
                <img src="/images/contact/In.svg" alt="In" />
              </a>
              <a href="http://" target="_blank" class="social_disabled">
                <img src="/images/contact/Facebook.svg" alt="Facebook" />
              </a>
            </div> -->
          </div>
        </div>
      </div>
      <transition name="slide">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
import { TweenLite, Power2 } from 'gsap'
import { globalMixin, scrollMixin } from './mixins'
import preloader from './views/parts/preloader'
import CookieLaw from 'vue-cookie-law'

export default {
  mixins: [ globalMixin, scrollMixin ],

  components: {
    preloader,
    CookieLaw,
  },

  data() {
    return {
      showMenu: false,
    }
  },

  computed: {
    navigationColor () {
      return this.$store.getters.navigationColor
    },
    backgroundColor () {
      return this.$store.getters.backgroundColor
    },
    logoColor () {
      return this.$store.getters.logoColor
    },
    isMenuBurgerVisible () {
      return this.$store.getters.isMenuBurgerVisible
    },
    currentRouteName() {
      return this.$route.name;
    },
    hideNavigationByScroll() {
      if (this.currentRouteName === 'project') {
        return this.isScrollingDown;
      } else {
        return this.isMainMenuHidden;
      }
    },
  },

  methods: {
    onLogoHover( event ) {
      const logo = event.currentTarget
      TweenLite.to( logo, .5, {
        scale: 1.4,
        ease: Power2.easeInOut,
      } )
    },
    onLogoHoverOut( event ) {
      const logo = event.currentTarget
      TweenLite.to( logo, .5, {
        scale: 1,
        ease: Power2.easeInOut,
      } )
    },
    onMenuShow() {
      this.$refs.menu.style.display = 'block'
      TweenLite.to( this.$refs.menuBackground, .5, {
        opacity: 1,
        ease: Power2.easeInOut,
      } )
      TweenLite.to( this.$refs.menuContainer, .5, {
        x: '0%',
        ease: Power2.easeInOut,
      } )
      this.showMenu = true
    },

    onMenuTooggle() {
      if(this.showMenu) {
        this.onMenuHide()
      } else {
        this.onMenuShow()
      }
    },

    onMenuHide() {
      const self = this
      TweenLite.to( this.$refs.menuBackground, .5, {
        opacity: 0,
        ease: Power2.easeInOut,
        onComplete() {
          self.$refs.menu.style.display = 'none'
        }
      } )
      TweenLite.to( this.$refs.menuContainer, .5, {
        x: '100%',
        ease: Power2.easeInOut,
      } )
      this.showMenu = false
    },
  },

  mounted () {
    this.$store.commit('setFirstPage')
  },
}
</script>

<style lang="scss">
  @import './assets/css/normalize.css';
  @import './assets/vars.scss';

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom900-webfont.woff') format('woff');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom800-webfont.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom600-webfont.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom400-webfont.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom300-webfont.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'acrom';
    src: url('/fonts/acrom100-webfont.woff') format('woff');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'didot';
    font-weight: 700;
    src: url("/fonts/didot_bold.otf") format("opentype");
  }

  @font-face {
    font-family: 'didot';
    font-weight: 400;
    src: url("/fonts/didot_regular.otf") format("opentype");
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-MediumItalic.woff') format('woff');
      font-weight: 500;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-SuperItalic.woff') format('woff');
      font-weight: normal;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-SemiboldItalic.woff') format('woff');
      font-weight: 600;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Black.woff') format('woff');
      font-weight: 900;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Super.woff') format('woff');
      font-weight: normal;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Thin.woff') format('woff');
      font-weight: 100;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-ExtralightItalic.woff') format('woff');
      font-weight: 200;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Regular.woff') format('woff');
      font-weight: normal;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-BoldItalic.woff') format('woff');
      font-weight: bold;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-LightItalic.woff') format('woff');
      font-weight: 300;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-BlackItalic.woff') format('woff');
      font-weight: 900;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Medium.woff') format('woff');
      font-weight: 500;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Light.woff') format('woff');
      font-weight: 300;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Semibold.woff') format('woff');
      font-weight: 600;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Bold.woff') format('woff');
      font-weight: bold;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-Extralight.woff') format('woff');
      font-weight: 200;
      font-style: normal;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-ThinItalic.woff') format('woff');
      font-weight: 100;
      font-style: italic;
  }

  @font-face {
      font-family: 'Graphik LCG';
      src: url('/fonts/GraphikLCG-RegularItalic.woff') format('woff');
      font-weight: normal;
      font-style: italic;
  }

  #app .Cookie--base {
    all: unset;
    background: #FFFFFF;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);    
    position: fixed;
    bottom: 20px;
    left: auto;
    right: 20px;
    max-width: 375px;
    padding: 30px;
    display: block;
    z-index: 99;
    @media #{$mb} {
      right: auto;
      left: 0px;
      bottom: 0px;
      width: 100%;
      max-width: 100vw;
      padding: 10px 0px 10px 20px;
      box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.3);
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #303030;
      opacity: 0.5;
      letter-spacing: -0.03em;
      margin: 0;
      padding: 0;
       @media #{$mb} {
        padding: 0 40px 0 0;
      }
    }

    .cookie-btn {
      all: unset;
      margin-top: 30px;
      @media screen #{$mb} {
        margin-top: 20px;
      }
      span {
        cursor: pointer;
        font-style: normal;
        font-weight: 400;
        font-size: 26px;
        line-height: 130%;
        letter-spacing: -0.03em;
        color: #000000;
        text-decoration: none;
        color: inherit;
        transition: text-decoration-color 0.2s;
        position: relative;
        &:hover {
          &:before {
            content: "";
            position: absolute;
            width: 100%;
            bottom: -2px;
            left: 0;
            border-bottom: 1px solid rgba(38, 38, 38, 1);
          }
        }
        &:before {
          content: "";
          position: absolute;
          width: 0%;
          bottom: -2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 1);
          transition: 0.2s;
        }
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          bottom: -2px;
          left: 0;
          border-bottom: 1px solid rgba(38, 38, 38, 0.1);
        }
        @media #{$mb} {
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 130%;
        }
      }
    }

    .Cookie--bottom {
      all: unset;
      left: auto;
      right: 20px;
      @media screen #{$mb} {
        right: 0px;
      }
    }
  }

  html {
    font-size: 16px;

    @media screen #{$mb} {
      font-size: 16px;
    }

    @media screen and (min-width: 769px) {
      @media screen and (max-width: 1200px) {
        font-size: 15px;
      }

      @media screen and (max-width: 1150px) {
        font-size: 14px;
      }

      @media screen and (max-width: 1100px) {
        font-size: 13px;
      }

      @media screen and (max-width: 1050px) {
        font-size: 12px;
      }

      @media screen and (max-width: 1000px) {
        font-size: 11px;
      }

      @media screen and (max-width: 950px) {
        font-size: 10px;
      }

      @media screen and (max-width: 850px) {
        font-size: 9px;
      }
    }
  }

  body {
    overflow-y: scroll;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Graphik LCG';
    font-size: 16PX;
    color: #303030;
    background: #F4F4F4;
  }

  .a-link {
    cursor: pointer;
    color: inherit;
    text-decoration: inherit;
  }

  .wrapper {
    padding-left: rem(172px);
    padding-right: rem(172px);

    max-width: 1450px;

    @media(min-width: 1500px) {
      max-width: 1200px;
      margin: 0 auto;
    }

    @media #{$mb} {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .menu-logo {
    position: fixed;
    text-decoration: none;
    z-index: 6;
    top: rem(25px);
    left: rem(60px);
    font-weight: 700;
    font-size: rem(22px);
    color: inherit;
    letter-spacing: 0;
    line-height: rem(64px);
    transition: all .2s ease;
    // backface-visibility: hidden;

    &._white {
      color: #fff;
    }

    &._black {
      color: #303030;
    }
    
    &.isHiddenByScroll {
      transform: translateY(-200%);
    }

    svg {
      @media #{$mb} {
        width: 95px
      }
    }

    @media #{$mb} {
      left: rem(20px);
      top: rem(20px);
      font-size: rem(20px);
      letter-spacing: rem(4px);
      line-height: rem(22px);
    }
  }

  .menu-burger {
    position: fixed;
    z-index: 101;
    top: rem(0px);
    right: rem(20px);
    width: rem(80px);
    height: rem(80px);
    transition: all .2s ease;

    &.isHidden {
      opacity: 0 !important;
      pointer-events: none;
    }

    &.isHiddenByScroll {
      transform: translateY(-200%);
    }

    @media #{$mb} {
      right: rem(10px);
      top: rem(15px);
      width: rem(40px);
      height: rem(40px);
      cursor: default;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: rem(40px);
      margin-left: rem(-20px);
      height: rem(3px);
      margin-top: rem(-1.5px);

      @media #{$mb} {
        width: rem(38px);
        height: rem(3px);
        margin-left: rem(-24px);
      }

      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #303030;
        transition: all .2s ease;
      }

      &:before {
        transform: translateY(-200%);

        @media #{$mb} {
          transform: translateY(-170%);
        }
      }

      &:after {
        transform: translateY(200%);

        @media #{$mb} {
          transform: translateY(170%);
        }
      }
    }

    span.active {
      &:before {
        transform: rotate(45deg) translateY(0%);
      }

      &:after {
        transform: rotate(-45deg) translateY(0%);
      }
    }
  }

  ._white {
    .index__menu {
        color: #fff;
    }

    .menu-burger {
        span {
            &:before,
            &:after {
                background: #fff;
            }
        }
    }

    .menu-logo {
      color: #fff;
    }

    .index__dots__item {
      span {
        background: #fff;
      }
    }

    .index__menu__link.hover-link {
      &:after {
        background: #fff;
      }
    }
  }

  ._background-black {
    background: #303030;
    color: #fff;

    .container__left,
    .container__right {
      border-color: transparent;
    }
  }

  .container {
    display: flex;
    min-height: 100vh;

    @media #{$mb} {
      display: block;
    }
  }

  .container__left {
    position: relative;
    width: rem(300px);
    min-width: rem(300px);
    border-right: rem(1px) solid #D0D0D0;

    @media #{$mb} {
      display: none;
    }
  }

  .container__image {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    width: rem(300px);
    bottom: 0;
    background: {
      size: cover;
      position: center;
    }
    transition: all .2s ease;

    &.isHidden {
      opacity: 0;
    }
  }

  .container__center {
    position: relative;
    width: 100%;
  }

  .container__right {
    width: rem(80px);
    min-width: rem(80px);

    @media #{$mb} {
      display: none;
    }
  }

  .menu {
    display: none;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .menu__container {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    background: #fff;
    width: rem(500px);
    height: 100vh;
    transform: translateX(100%);
    display: flex;
    padding-left: rem(80px);
    box-sizing: border-box;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    @media #{$mb} {
      width: 100%;
      padding-left: rem(45px);
    }
  }

  .menu__inner {
    padding: 148px 0 80px;
  }

  .menu__block {
    margin-top: rem(40px);

    &:first-child {
      margin-top: 0;
    }
  }

  .menu__title {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.03em;
    color: #303030;
  }

  .a-link.menu__title {
    text-decoration: none;
    letter-spacing: -0.04em;
    transition: 0.2s;
    position: relative;
    &:hover {
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        bottom: -2px;
        left: 0;
        border-bottom: 1px solid rgba(38, 38, 38, 1);
      }
    }
    &:before {
      content: "";
      position: absolute;
      width: 0%;
      bottom: -2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 1);
      transition: 0.2s;
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: -2px;
      left: 0;
      border-bottom: 1px solid rgba(38, 38, 38, 0.1);
    }
  }

  .menu__link {
    margin-top: rem(20px);

    a {
      text-decoration: underline;
      text-underline-offset: 3px;
      text-decoration-color: #979797;
      letter-spacing: -0.04em;
      text-decoration-thickness: 1px;
      color: inherit;
      transition: 0.2s;
      &:hover {
        text-decoration-thickness: 1px;
        text-decoration: underline;
      }
    }
  }

  .menu__background {
    position: absolute;
    opacity: 0;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .7);
  }

  .menu__close {
    position: absolute;
    top: rem(30px);
    right: rem(21px);
    width: rem(28px);
    height: rem(28px);
    cursor: pointer;

    @media #{$mb} {
      cursor: default;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: rem(19px);
      height: rem(19px);
      margin-top: rem(-(19/2)+px);
      margin-left: rem(-(19/2)+px);
      
      &:before,
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -1px;
        margin-left: rem(-12px);
        background: #000;
        width: rem(24px);
        height: 2px;
      }

      &:before {
        transform: rotate(-45deg);
      }

      &:after {
        transform: rotate(45deg);
      }
    }
  }

  .menu__footer {
    position: absolute;
    left: rem(80px);
    bottom: rem(30px);
    opacity: 0.9;
    font-size: rem(12px);
    color: #303030;
    letter-spacing: 0.33px;
    line-height: rem(14px);

    @media #{$mb} {
      display: none;
    }

    a {
      color: inherit;
    }
  }

  .fixed-header {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;

    @media #{$mb} {
      left: 0;
      right: 0;
    }
  }

  .fixed-menu {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    right: 0;

    @media #{$mb} {
      left: 0;
      right: 0;
    }
  }

  .bg-white {
    background: #F4F4F4;
  }

  .scroll-header {
    height: rem(96px);
    line-height: rem(96px);
    text-align: center;
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    transition: all .2s ease;

    @media #{$mb} {
      height: rem(64px);
      line-height: rem(64px);
      z-index: 5;
    }

    &.isVisible {
      opacity: 1;
      pointer-events: auto;
    }

    &.isHiddenByScroll {
      transform: translateY(-100%);
    }
  }

  .scroll-menu {
    opacity: 0;
    pointer-events: none;
    cursor: pointer;
    transition: all .2s ease;

    @media #{$mb} {
      height: rem(64px);
      line-height: rem(64px);
      z-index: 5;
    }

    &.isVisible {
      opacity: 1;
      pointer-events: auto;
    }

    &.isHiddenByScroll {
      transform: translateY(-100%);
    }
  }

  .scroll-header__title {
    font-family: 'Didot';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;

    @media #{$mb} {
      font-size: rem(18px);
    }
  }

  .loader {
    position: fixed;
    z-index: -1;
    top: -9999px;
    left: -9999px;
    pointer-events: none;
    opacity: 0;
  }

  /* Container */

  .container__cursor {
    position: fixed;
    top: 50%;
    left: rem(150px);
    transform: translate(-50%, -50%) rotate(-90deg);
    font-weight: 500;
    font-size: rem(18px);
    color: #000000;
    letter-spacing: 0.38px;
    line-height: rem(24px);
  }

  .arrow-left {
    position: fixed;
    z-index: 4;
    top: rem(39px);
    left: rem(361px);

    @media #{$mb} {
      display: none;
    }
  }

  .progress {
    position: fixed;
    top: 0;
    height: 4px;
    z-index: 4;
    left: 0;
    right: 0;

    @media #{$mb} {
      left: 0;
      right: 0;
      z-index: 5;
      height: 2px;
    }
  }

  .progress__bar {
    background: #303030;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0%;
  }

  .fixed-left-menu {
    position: fixed;
    top: rem(36px);
    z-index: 3;
    left: rem(460px);

    @media #{$mb} {
      display: none;
    }

    a {
      display: inline-block;
      margin-left: rem(60px);
      font-weight: 500;
      font-size: rem(18px);
      color: #303030;
      letter-spacing: 0.38px;
      line-height: rem(24px);
      text-decoration: none;

      &:first-child {
        margin-left: 0;
      }

      &.router-link-exact-active,
      &.isActive {
        opacity: .3;
      }
    }
  }

  .mobile-cursor {
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    top: rem(21px);
    z-index: 3;
    text-align: center;
    font-weight: 500;
    font-size: rem(18px);
    color: #303030;
    letter-spacing: 0.38px;
    line-height: rem(24px);

    &._white {
      color: #FFFFFF;
    }

    @media #{$mb} {
      display: block;
    }
  }


  @keyframes page-changer {
    0%   { transform: scale(1); }
    50%  { transform: scale(.8); }
    100% { transform: scale(1); }
  }

  .page-changer {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #FAFAFA;

    div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      // animation: page-changer 2s infinite;
    }

    svg {
      display: block;
      position: absolute;
      max-width: 140px;
      width: 25%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) !important;
    }
  }

  .fixed-arrow {
    position: fixed;
    z-index: 4;
    right: rem(34px);
    bottom: rem(44px);
    width: rem(22px);
    height: rem(43px);
    background: url(/images/page-arrow-up.svg) center / contain no-repeat;
    cursor: pointer;
    transition: all .5s ease;
    
    @media #{$mb} {
      display: none;
    }

    &.isRotated {
      transform: rotate(-180deg);
    }

    &.isHidden {
      opacity: 0 !important;
    }

    &._no-transition {
      transition: all 0s ease;
    }
  }

  .hover-link {
    position: relative;

    &:after {
      content: "";
      position: absolute;
      height: 1px;
      background: #030303;
      left: 50%;
      bottom: -.1em;
      transform: translateX(-50%);
      width: 0%;
      transition: all .3s ease;
    }

    &:hover {
      &:after {
        width: 100%;
      }
    }

    &._white {
      &:after {
        background: #fff;
      }
    }
  }

  .page-cursor {
    position: fixed;
    left: rem(188px);
    top: rem(36px);
    z-index: 4;
    font-weight: 500;
    font-size: rem(18px);
    color: #000000;
    letter-spacing: 0.38px;
    line-height: rem(24px);
    transition: all .2s ease;

    &.isHiddenByScroll {
      transform: translateY(-300%);
    }

    @media #{$mb} {
      display: none;
    }

    @media (min-width: 1441px) {
      left: calc(5% + 100px);
    }

    @media (min-width: 1460px) {
      left: calc(6% + 100px);
    }

    @media (min-width: 1480px) {
      left: calc(7% + 100px);
    }

    @media (min-width: 1500px) {
      left: calc(7% + 100px);
    }

    @media (min-width: 1550px) {
      left: calc(8% + 100px);
    }

    @media (min-width: 1580px) {
      left: calc(9.5% + 100px);
    }

    @media (min-width: 1610px) {
      left: calc(10% + 100px);
    }

    @media (min-width: 1630px) {
      left: calc(10.5% + 100px);
    }

    @media (min-width: 1650px) {
      left: calc(11.2% + 100px);
    }

    @media (min-width: 1680px) {
      left: calc(12% + 100px);
    }

    @media (min-width: 1700px) {
      left: calc(12% + 100px);
    }

    @media (min-width: 1715px) {
      left: calc(13% + 100px);
    }

    @media (min-width: 1730px) {
      left: calc(13% + 100px);
    }

    @media (min-width: 1760px) {
      left: calc(14% + 100px);
    }

    @media (min-width: 1800px) {
      left: calc(15% + 100px);
    }

    @media (min-width: 1920px) {
      left: calc(15.5% + 100px);
    }
  }

  ._white {
    .page-cursor {
      color: #fff;
    }
  }

  .project__preview {
    position: relative;
    color: #fff;
    height: 800px;
    min-height: 450px;
    display: flex;
    align-items: flex-end;
    background: {
      size: cover;
      position: center;
    }

    @media #{$mb} {
      height: 270px;
      min-height: auto;
    }

    &:before {
      content: "";
      position: absolute;
      z-index: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.65) 70%, rgba(0,0,0,0.65) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 70%,rgba(0,0,0,0.65) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 70%,rgba(0,0,0,0.65) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#a6000000',GradientType=0 ); /* IE6-9 */
    }
  }

  .project__preview-content {
    // position: relative;
    z-index: 1;
    width: 100%;
    padding: 0 0 36px;

    @media #{$mb} {
      padding: 0 0 20px;
    }
  }

  .menu__nav {
    display: flex;
    gap: 20px;
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 50px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.03em;
    margin-left: 30px;

    .a-link {
      opacity: 0.8;
      transition: opacity 0.2s;
      &:hover {
        opacity: 1;
      }
    }
  }

  .menu__social {
    display: flex;
    margin-top: 57px;
    justify-content: flex-start;
    gap: 30px;

    a:not(.social_disabled) {
      opacity: 1;
      transition: opacity 0.2s;
      &:hover {
        opacity: 0.7;
      }
    }

    .social_disabled {
      opacity: 0.5;
      cursor: auto;
    }
  }
</style>
